﻿@Component('Umbrella', {
    selector: 'occupant-role-label',
    template: `
        <role-label label-text="MB" label-title="Medebewoner"></role-label>
    `
})
class OccupantRoleLabelComponent {}
